import { Button, VStack } from "@chakra-ui/react"
import Pathicon from "../../pathicon/Pathicon"
import { PathCreatorRawValues } from "./state"
import { transient } from "./style"
import useLazyRandomThemeResourceImage from "./useLazyRandomThemeResourceImage"

export function useGetNewResource() {
  const [loadImage, { loading }] = useLazyRandomThemeResourceImage({
    fetchPolicy: "network-only"
  })

  // Handles choosing to create resource.
  async function getNewResource(): Promise<PathCreatorRawValues> {
    const { data } = await loadImage()
    const [defaultImage, image, burredImage] = data?.resourceImage || []

    return {
      resource: {
        id: -1,
        name: "",
        image: image,
        background_image: burredImage,
        sourceCohort: {
          id: -1,
          role: null
        }
      },
      cohort: null
    }
  }

  return { getNewResource, loading }
}

type CreateOrSelectResourceProps = {
  onSelect: (value: PathCreatorRawValues) => void
}

function CreateOrSelectResource({ onSelect }: CreateOrSelectResourceProps) {
  const { getNewResource, loading } = useGetNewResource()

  // Handles choosing to create resource.
  async function handleCreateNewResource() {
    onSelect(await getNewResource())
  }

  // Handles choosing to select resource.
  function handleSelectExistingResource() {
    onSelect({
      resource: null,
      cohort: null
    })
  }

  return (
    <VStack w="100%" {...transient}>
      <Button
        colorScheme="blackAlpha"
        w="100%"
        onClick={() => handleCreateNewResource()}
        leftIcon={<Pathicon icon="plus" />}
        autoFocus
        isLoading={loading}
      >
        Create new
      </Button>
      <Button
        colorScheme="blackAlpha"
        w="100%"
        onClick={() => handleSelectExistingResource()}
        leftIcon={<Pathicon icon="search-list" />}
        isDisabled={loading}
      >
        Select existing...
      </Button>
    </VStack>
  )
}

export default CreateOrSelectResource
